import { Button, Typography } from 'antd'

import { SubscriptionService } from '@services/SubscriptionService'
import { useConfirmation } from '@store/confirmation'
import { useNotifications } from '@store/notifications'

const SubscriptionDashboardPage = () => {
    const confirm = useConfirmation()
    const { showNotification } = useNotifications()

    const updateSubscriptionStatus = async () => {
        if (
            await confirm({
                title: 'Update subscription status',
                description:
                    'This will update all subscriptions. Expired subscriptions will go INACTIVE and subscriptions within the start/end date will go ACTIVE'
            })
        ) {
            const result = await SubscriptionService.updateSubscriptionStatus()

            showNotification({
                title: 'Subscription status check complete',
                description: `${result.activated.count} activated, ${result.completed.count} completed`
            })
        }
    }

    return (
        <>
            <Typography.Title>Subscriptions</Typography.Title>
            <p>Subscription status checks are automated. Press the button to do a manual subscription update.</p>
            <Button type="primary" onClick={updateSubscriptionStatus}>
                Manual Subscription Status Check
            </Button>
        </>
    )
}

export default SubscriptionDashboardPage
